export const styles = {
  card: {
    ':first-of-type': { marginLeft: 0 },
    ':last-child': { marginRight: 0 },
    ':hover': {
      outline: '0.125rem solid',
    },
  },
  button: {
    display: 'flex',
    minWidth: 'inherit',
    padding: 0,
  },
};
